import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAdminAuth } from '@/auth/require-admin-auth';

const SelectTenantPage = lazy(() => import('@/features/auth/select-tenant-page'));
const LoginPage = lazy(() => import('@/features/auth/login-page'));
const ChangePasswordPage = lazy(() => import('@/features/auth/change-password-page'));
const AppShell = lazy(() => import('@/components/layout/app-shell'));
// Feature pages — created in Tasks 7-10. Stub imports here; Vite will code-split them.
const ManifestListPage = lazy(() => import('@/features/manifests/list-page'));
const ManifestDetailPage = lazy(() => import('@/features/manifests/detail-page'));
const ManifestDiffPage = lazy(() => import('@/features/manifests/diff-page'));
const DocumentsListPage = lazy(() => import('@/features/documents/list-page'));
const DocumentDetailPage = lazy(() => import('@/features/documents/detail-page'));
const CredentialListPage = lazy(() => import('@/features/credentials/list-page'));
const UserListPage = lazy(() => import('@/features/users/list-page'));
const ModelsPage = lazy(() => import('@/features/settings/models-page'));
const AppearancePage = lazy(() => import('@/features/settings/appearance-page'));
const ToolApiPage = lazy(() => import('@/features/settings/tool-api-page'));
const NavigationPage = lazy(() => import('@/features/settings/navigation-page'));
const InstallPage = lazy(() => import('@/features/settings/install-page'));
const AgentPage = lazy(() => import('@/features/settings/agent-page'));
const ConversationsListPage = lazy(() => import('@/features/conversations/list-page'));
const ConversationsTranscriptPage = lazy(() => import('@/features/conversations/transcript-page'));

export const router = createBrowserRouter([
  { path: '/', element: <SelectTenantPage /> },
  { path: '/tenants/:slug/login', element: <LoginPage /> },
  {
    element: <RequireAdminAuth />,
    children: [
      { path: '/tenants/:slug/change-password', element: <ChangePasswordPage /> },
      {
        element: <AppShell />,
        children: [
          { path: '/tenants/:slug', element: <Navigate to="manifests" replace /> },
          { path: '/tenants/:slug/manifests', element: <ManifestListPage /> },
          { path: '/tenants/:slug/manifests/:id', element: <ManifestDetailPage /> },
          { path: '/tenants/:slug/manifests/:id/diff/:otherId', element: <ManifestDiffPage /> },
          { path: '/tenants/:slug/documents', element: <DocumentsListPage /> },
          { path: '/tenants/:slug/documents/:id', element: <DocumentDetailPage /> },
          { path: '/tenants/:slug/conversations', element: <ConversationsListPage /> },
          { path: '/tenants/:slug/conversations/:id', element: <ConversationsTranscriptPage /> },
          { path: '/tenants/:slug/credentials', element: <CredentialListPage /> },
          { path: '/tenants/:slug/users', element: <UserListPage /> },
          { path: '/tenants/:slug/settings/models', element: <ModelsPage /> },
          { path: '/tenants/:slug/settings/appearance', element: <AppearancePage /> },
          { path: '/tenants/:slug/settings/tool-api', element: <ToolApiPage /> },
          { path: '/tenants/:slug/settings/navigation', element: <NavigationPage /> },
          { path: '/tenants/:slug/settings/install', element: <InstallPage /> },
          { path: '/tenants/:slug/settings/agent', element: <AgentPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
